<template>
    <section class="page">
		<div class="top"><p>Hi, welcome!</p></div>
		<div class="co-status">
			<!--分期产品-->
			<template v-if="userInfo.fqProductSeries">
				<!--有单-->
				<template v-if="onTheWayFqOrder">
					<!-- 申请中 -->
					<audit-status v-if="onTheWayFqOrder.status < 70" :onTheWayOrder="onTheWayFqOrder" productType="DFEP" />

					<!-- 还款中 -->
					<credit-status v-else-if="onTheWayFqOrder.status == 70" :onTheWayOrder="onTheWayFqOrder" productType="DFEP" />

					<!-- 逾期 -->
					<overdue-status v-else-if="onTheWayFqOrder.status == 80" :onTheWayOrder="onTheWayFqOrder" productType="DFEP" />
				</template>
				<fq-status v-else :type="2" :data="userInfo"></fq-status>
			</template>
			<template v-if='productSeries'>
				<!-- 未进件，进件中 -->
				<fq-status v-if="showModule==7" :type="3" :data="userInfo" @apply="apply"></fq-status>
				
				<!-- 进件完成,复贷 -->
				<default-status v-if="showModule==1" :userInfo="userInfo" productType="DF"></default-status>
				
				<!-- 进件完成，申请中 -->
				<audit-status v-if="showModule==2" :onTheWayOrder="onTheWayOrder" productType="DF"></audit-status>
				
				<!-- 进件完成，未结清 -->
				<credit-status v-if="showModule==3" :onTheWayOrder="onTheWayOrder" productType="DF"></credit-status>
				
				<!-- 进件完成，逾期 -->
				<overdue-status v-if="showModule==4" :onTheWayOrder="onTheWayOrder" productType="DF"></overdue-status>
				
				<!-- 进件流程 -->
				<!-- <apply-status v-if="showModule==6" :userInfo="userInfo" productType="DF"></apply-status> -->
			</template>
			
			<template v-if='vipProductSeries'>
				<!-- 未进件，进件中 -->
				<fq-status v-if="showVipModule==7" :type="3" :data="userInfo" @apply="applyVip"></fq-status>
				
				<!-- 进件完成,复贷 -->
				<default-status v-if="showVipModule==1" :userInfo="userInfo" productType="DFVIP"></default-status>
				
				<!-- 申请中 -->
				<audit-status v-if="showVipModule==2" :onTheWayOrder="onTheWayVipOrder" productType="DFVIP"></audit-status>
				
				<!-- 未结清 -->
				<credit-status v-if="showVipModule==3" :onTheWayOrder="onTheWayVipOrder" productType="DFVIP"></credit-status>
				
				<!-- 逾期 -->
				<overdue-status v-if="showVipModule==4" :onTheWayOrder="onTheWayVipOrder" productType="DFVIP"></overdue-status>
				
				<!-- 进件流程 -->
				<!-- <apply-status v-if="showVipModule==6" :userInfo="userInfo" productType="DFVIP"></apply-status> -->
			</template>
			<template v-if='!cToken'>
				<!-- 未登录 -->
				<fq-status :type="1"></fq-status>
			</template>
		</div>
		
		<div class="ad-wrap"  v-if="userInfo.hasgg == 1" @click="tapAdd">
			<div class="df-banner"></div>
		</div>
		
		<div class="pop" v-if="isShowJump">
		    <div class="pop-con">
		        <p>Please note that you will be directed to a third-party company's website upon clicking</p>
				<div class="btn_wrap">
					<a @click="isShowJump = false">Cancel</a>
					<a @click="jumpToDf">Confirm</a>
				</div>
		    </div>
		</div>
		<div class="winner">
			<div class="win-con" :class="{'list-animation': addAnimation}">
				<p v-for="(item, index) in winnerList" :key="index" v-text="item" />
			</div>
		</div>
		<div class="safe">
			<div class="safe-title">Easy Fast Safe</div>
			<div class="safe-con">
				<a @click="jump(1)"><p>My Score</p><span v-text="userInfo.scoreTotal" /></a>
				<a @click="jump(2)">Gifts</a>
				<a @click="jump(3)">Coupons<b>{{usableCount}}</b></a>
			</div>
			<p class="coupons-num" v-if='usableCount && customerId'>You have available coupons, come and check them out!</p>
		</div>
		<template v-if="showModule==1 || showVipModule==1 || showModule==7">
			<div class="introduce"></div>
			<div class="foot">DF Credit Lending Corporation<br />Company Registration No. :CS202002430<br />Certificate of Authority NO.3244</div>
		</template>
		<cusMesPopup v-if = "isShowMessage" @submitMessage="submitMessage" @close='isShowMessage = false'></cusMesPopup>
		<hint v-if="showHint" :data="hintData" @closePop="closePop" />
    </section>
</template>

<script>
import defaultStatus from "./defaultStatus";
import auditStatus from "./auditStatus";
import creditStatus from "./creditStatus";
import overdueStatus from "./overdueStatus";
import applyStatus from "./applyStatus";
import fqStatus from "./fqStatus";
import cusMesPopup from "@components/cusMesPopup";
import hint from '../integral/hint.vue'
export default{
    data(){
        return {
			userInfo:{},
			productList:[],
			winnerList: [],
            addAnimation: false,
			showModule:1,
			showVipModule:-1,
			onTheWayFqOrder: null,
			onTheWayOrder:{},			//订单信息
			onTheWayVipOrder:{},
			productSeries:"",
			vipProductSeries:"",
			status: '',
			isShowJump:false,
			customerId: '',
			isShowMessage:false,
			showHint:false,
			hintData:{
				conText: "<p style='margin-bottom:0.3rem;line-height:0.34rem'>Dear client,</p>\
					<p style='margin-bottom:0.3rem;line-height:0.34rem'>We have specially crafted a worry-free loan experience for you!</p>\
					<p style='margin-bottom:0.3rem;line-height:0.34rem'><strong>Enjoy 5 days of free usage</strong> with no interest and service free burden. Coupon has issued to your account already! Please don't forget to select the coupon when submit application.</p>\
					<p style='margin-bottom:0.3rem;line-height:0.34rem'>After receiving the funds, you can return the disbursed amount at any time within 5 days for clearance, without any reason. </p>\
					<p style='margin-bottom:0.3rem;line-height:0.34rem'>Opportunities are limited—act now and easily solve your financial needs!</p>",
				btnText: 'GO APPLY',
				type: 1
			},
			hasCouponTime:"",
			usableCount:1,
			cToken:""
        }
    },
    metaInfo: {
        title: 'Funpera'
    },
    
    created: function() {
        let self = this;
		this.cToken = this.UTILS.getParam('cToken');
		this.hasCouponTime = this.UTILS.getParam('hasCouponTime');
		if(this.cToken){
			this.getUserInfo();
		}
		this.getLoanlist();
    },

    methods:{
		//中奖信息
		getLoanlist(){
			let self = this;
			self.UTILS.axiosRequest('post', self.PATHS.loanPath + '/activity/getLoanlist', {}, function(res){
				self.UTILS.loadGif.hide();
				if(res.code == '0000'){
					self.winnerList = res.data;
					if(self.winnerList && self.winnerList.length){
						self.rollList();
					}
				}
			});
		},

		//滚动中奖名单
        rollList(){
            var self = this;
            setInterval(() => {
                self.addAnimation = true;
                setTimeout(function(){
                    self.addAnimation = false;
                    var firstItem = self.winnerList[0];
                    self.winnerList.splice(0,1);
                    self.winnerList.push(firstItem);
                },980);
            }, 2000);
        },

		//埋点
		maidian(type){
			let self = this;
			if(self.customerId){
				self.UTILS.axiosRequest('post', self.PATHS.loanPath + '/maidian/add', {
					customerId: self.customerId,
					type: type
				}, function(){
					self.UTILS.loadGif.hide();
				}, 1);
			}
		},

		//点击广告
		tapAdd(){
			let self = this;
			self.maidian(2);
			self.isShowJump = true;
		},

		getUserInfo() {
			let self = this;
			self.UTILS.axiosRequest('post', self.PATHS.loanPath + '/user/getUserInfo', {}, function(res) {
				self.UTILS.loadGif.hide();
				if (res.code == '0000') {
					self.getCoupons();
					self.userInfo = res.data;
					self.status = res.data.status;
					self.productSeries = self.userInfo.productSeries;
					self.vipProductSeries = self.userInfo.vipProductSeries;
					self.customerId = self.userInfo.customerId;
					self.showHint = res.data.hasMxcoupon == 1 && self.hasCouponTime != new Date().toDateString() ? true : false;
					if(self.showHint){
						self.UTILS.setParam('hasCouponTime', new Date().toDateString());
					}
					if(self.userInfo.hasgg == 1){
						self.maidian(1);
					}
					if(self.userInfo.status == "6"){
						const source = self.UTILS.getParam('source');
						self.onTheWayOrder = self.userInfo.onTheWayOrder;
						self.onTheWayVipOrder = self.userInfo.onTheWayVipOrder
						self.userInfo.onTheWayFqOrder && (self.onTheWayFqOrder = self.userInfo.onTheWayFqOrder);
						if(self.userInfo.onTheWayOrder && self.userInfo.onTheWayOrder.status){//有在途订单
							let status = self.userInfo.onTheWayOrder.status;
							if(status < 90){
								self.enums(status)
							}
							else{
								self.showModule = 1;	//进件完成，订单状态异常
							}
						}else{
							self.showModule = 1;		//进件完成，没有订单
						}
						
						//vip产品
						if(self.userInfo.onTheWayVipOrder && self.userInfo.onTheWayVipOrder.status){//有在途订单
							let status = self.userInfo.onTheWayVipOrder.status;
							if(status < 90){
								self.enumsVip(status)
							}
							else{
								self.showVipModule = 1;
							}
						}else{
							self.showVipModule = 1;
						}
						if(self.userInfo.onTheWayOrder || self.userInfo.onTheWayVipOrder){
							const loanType = self.userInfo.onTheWayOrder.loanType || self.userInfo.onTheWayVipOrder.loanType
							if(source == "loan" && loanType == 1){//页面来源为提交订单页面,并且是首贷
								self.isShowMessage = true
							}
						}
					}
					else{//未进件，进件中
						self.showModule = 7;
						self.showVipModule = 7;
					}
				} else {
					self.showModule = 7;
				}
			}, 1);
		},
		
		enums(status){
			if(Number(status) < 70){//10 20 30 40 50 60 65，申请中
				this.showModule = 2;
			}else if(status == 70){//未结清
				this.showModule = 3;
			}else if(status == 80){//逾期
				this.showModule = 4;
			}
		},
		
		enumsVip(status){
			if(Number(status) < 70){//10 20 30 40 50 60 65，申请中
				this.showVipModule = 2;
			}else if(status == 70){//未结清
				this.showVipModule = 3;
			}else if(status == 80){//逾期
				this.showVipModule = 4;
			}
		},
		
		apply(){
			// this.showModule = 6;
			// this.showVipModule = -1;
			location.href = "./infoGuidance.html?productType=DF&status="+this.userInfo.status
		},
		
		applyVip(){
			// this.showVipModule = 6;
			// this.showModule = -1
			location.href = "./infoGuidance.html?productType=DFVIP&status="+this.userInfo.status
		},
		
		toActivety(){
			location.href = "./sdjActivity.html"
		},
		jump(type){
			const cToken = this.UTILS.getParam('cToken');
			if(cToken){
				if(Number(this.userInfo.status) < 6){//未进件
					location.href = "./infoGuidance.html?productType=DF&status="+this.userInfo.status
				}
				else{
					if(type == 1){
						location.href = "./rewards.html?tab=1"
					}
					else if(type == 2){
						location.href = "./rewards.html"
					}
					else if(type == 3){
						location.href = "./coupon.html"
					}
				}
			}
			else{
				this.UTILS.backLogin()
			}
		},
		jumpToDf(){
			location.href = this.userInfo.ggurl
		},
		submitMessage(parmas){
			var self = this;
			const onTheWayOrder = self.userInfo.onTheWayOrder || {};
			const onTheWayVipOrder = self.userInfo.onTheWayVipOrder || {};
			const orderId = onTheWayOrder.orderId || onTheWayVipOrder.orderId;
			self.UTILS.axiosRequest('post', self.PATHS.loanPath + '/order/addCustomerMessage', {orderId:orderId,...parmas}, function(res) {
				self.UTILS.loadGif.hide();
				if (res.code == '0000') {
					self.UTILS.logStr(res.message);
					self.isShowMessage = false;
				} else {
					self.UTILS.logStr(res.message);
				}
			},1);
		},
		closePop(val){
			if(val){
				if(Number(this.userInfo.status) < 6){
					location.href = "./infoGuidance.html?productType=DF&status="+this.userInfo.status
				}
				else{
					location.href = "./loan.html?productType=DF"
				}
			}
			else{
				this.showHint = false;
			}
		},
		//获取优惠券
		getCoupons(){
			var self = this;
			self.UTILS.axiosRequest('post', self.PATHS.loanPath + '/coupon/queryCouponList', {
				provideType: 1
			}, function(res){
				self.UTILS.loadGif.hide();
				if(res.code == '0000'){
					self.usableCount = res.data?.usable?.length || 0;
				}else{
					self.UTILS.logStr(res.message);
				}
			});
		}
    },
	components: {
	    defaultStatus,
	    auditStatus,
	    creditStatus,
	    overdueStatus,
		applyStatus,
		fqStatus,
		cusMesPopup,
		hint
	}
}
</script>

<style scoped>
.page{ min-height: 100%; padding-bottom: 0.01rem; background-color: #FFF;}
.top{ width: 7.5rem; height: 4.94rem; padding-top: 0.6rem; background: url('./img/bg.png'); background-size: cover;}
.top p{ height: 0.6rem; padding-left: 0.78rem; line-height: 0.76rem; font-size: 0.36rem; color: #FCFCF9; background: url('./img/icon.png') no-repeat; background-size: 0.6rem; margin-left: 0.38rem;}
.co-status{margin-top: -2.4rem;}
.safe{ height: 4.1rem; background: url('./img/safe.png') no-repeat; background-size: cover; margin-top: 0.4rem;}
.safe-title{ width: 5.32rem; height: 0.46rem; line-height: 0.3rem; text-align: center; font-size: 0.26rem; color: #FFCEB3; background: url('./img/title.png') center; background-size: cover; margin: 0 auto;}
.safe-con{ height: 1rem; padding-left: 0.4rem; margin-top: 1.73rem;}
.safe-con a{ width: 1.9rem; height: 1rem; padding-left: 0.18rem; line-height: 1rem; font-size: 0.4rem; color: #FFF; float: left; margin-right: 0.49rem;}
.safe-con a:nth-child(2){ padding-left: 0.3rem;}
.safe-con a:nth-last-child(1){ padding-left: 0.08rem; margin-right: 0;position: relative;}
.safe-con p{ line-height: 0.54rem; font-size: 0.34rem; color: #FFF;}
.safe-con span{ line-height: 0.4rem; font-size: 0.3rem; display: block;}
.safe-con b{ position: absolute;top: 0.1rem;right: 0.15rem;padding: 0.04rem 0.08rem; line-height: 0.24rem; font-size: 0.24rem; font-weight: normal; color: #FFF; background-color: #FC6E51; border-radius: 0.18rem;}
.coupons-num{text-align: center;margin-top: 0.2rem;color: #000;}
.introduce{ height: 6.1rem; background: url('./img/introduce.png'); background-size: cover;}
.foot{ line-height: 0.28rem; text-align: center; font-size: 0.22rem; color: #999; margin-bottom: 0.16rem;}

.ad-wrap{margin: 0.3rem;}
.df-banner{display: flex;justify-content:flex-end;width: 100%;height: 2.36rem;background:url("./img/indAd.png") no-repeat center;background-size: 100% 100%;}
.df-banner img{height: 0.48rem;width: 1rem;margin-right: 0.3rem;margin-top: 0.1rem;}
.pop{ display: flex;align-items:center;justify-content:center;width: 100%; height: 100%; background: rgba(0,0,0,0.3); position: fixed; top: 0; left: 0;z-index: 9;}
.pop-con{ width: 6.0rem; padding: 0.3rem 0; background-color: #FFF; border-radius: 0.2rem;}
.pop-con p{ padding: 0 0.3rem; line-height: 0.38rem; text-align: center; font-size: 0.28rem; color: #333;}
.btn_wrap{ height: 0.62rem; margin: 1.0rem 0.4rem 0 0.4rem;}
.btn_wrap a{ width: 1.8rem; height: 0.66rem; line-height: 0.66rem; text-align: center; font-size: 0.32rem; color: #FFF;background-color: #FF8F1F; border-radius: 0.16rem;}
.btn_wrap a:nth-child(1){ float: left;}
.btn_wrap a:nth-child(2){ float: right;}

.winner{ height: 0.7rem; padding-left: 0.9rem; background: url('./img/icon8.png') no-repeat 0.2rem center; background-size: 0.6rem; overflow: hidden; position: relative;}
.win-con{ position: absolute; left: 0.9rem; top: 0;}
.win-con p{ line-height: 0.7rem; font-size: 0.3rem;}
.list-animation{ animation: myfirst 1s;}
@keyframes myfirst{
    from {top: 0;}
    to {top: -0.7rem;}
}
 
@-webkit-keyframes myfirst{
    from {top: 0;}
    to {top: -0.7rem;}
}
</style>